import { request } from '@umijs/max';
import type { OperatorUser } from '@/services/apiResponse';
import { getNebulithInferenceProApiUrl } from '@/services/util';

export type EntitlementOperatorUser = OperatorUser;

/** 当前用户的模型推理产品开通记录 */
export interface EntitlementSelf {
  entitlementId?: string;
  userId?: string;
  createAt?: string;
  createBy?: string;
  createUser?: EntitlementOperatorUser | null;
  updateAt?: string;
  updateBy?: string;
  updateUser?: EntitlementOperatorUser | null;
}

export function isEntitlementActivated(
  entitlement?: EntitlementSelf | null,
): boolean {
  return Boolean(String(entitlement?.entitlementId || '').trim());
}

export interface CreateEntitlementParams {
  userId: string;
}

/** 提交模型推理产品开通申请 */
export async function createEntitlement(
  params: CreateEntitlementParams,
  options?: { skipErrorHandler?: boolean },
) {
  return request<EntitlementSelf>(
    getNebulithInferenceProApiUrl('entitlement/create'),
    {
      method: 'POST',
      data: params,
      ...(options || {}),
    },
  );
}

/** 查询当前用户自己的推理产品开通记录 */
export async function getSelfEntitlement(options?: {
  skipErrorHandler?: boolean;
}) {
  try {
    const res = await request<EntitlementSelf | null>(
      getNebulithInferenceProApiUrl('entitlement/self'),
      {
        method: 'POST',
        data: {},
        skipErrorHandler: true,
        ...(options || {}),
      },
    );
    return res ?? null;
  } catch {
    return null;
  }
}
